import { makeStyles, Theme, Typography } from '@material-ui/core'
import { CloseOutlined, WarningOutlined } from '@material-ui/icons'
import { isEqual } from 'lodash'
import { useAppSelector } from 'store/configureStore'
import {
  IssueDto,
  IssueSeverity,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { bomItemIssuesSelector } from '../store/selectors/bomItemIssuesSelector'
import { useBomItemIssueDescription } from './useBomItemIssueDescription'

const useStyles = makeStyles((theme: Theme) => {
  return {
    warningColor: {
      color: theme.palette.warning.main,
    },
    issuesContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
  }
})

export const IssueSeverityIcon = (props: { severity: IssueSeverity }) => {
  const classes = useStyles()

  return props.severity === IssueSeverity.Error ? (
    <CloseOutlined color="error" />
  ) : (
    <WarningOutlined className={classes.warningColor} />
  )
}

const BomItemIssue = (props: { issue: IssueDto }) => {
  const classes = useStyles()
  const { getIssueDescription } = useBomItemIssueDescription()

  return (
    <li className={classes.issuesContainer}>
      <IssueSeverityIcon severity={props.issue.severity} />
      <Typography variant="body2">
        {getIssueDescription(props.issue)}
      </Typography>
    </li>
  )
}

export const BomItemIssues = (props: {
  bomItemId: string
  ulClassName?: string
  liClassName?: string
}) => {
  const issues = useAppSelector(bomItemIssuesSelector(props.bomItemId), isEqual)

  if (!issues?.length) {
    return null
  }

  return (
    <ul className={props.ulClassName}>
      {issues.map((x) => (
        <BomItemIssue key={x.id} issue={x} />
      ))}
    </ul>
  )
}
